import {signin, verifiyEmail} from '../.././../libs/api/api'
import constants from '../../../libs/constant/constants'
import pageRoutes from '../../../libs/constant/pageRoutes'
import {message, errorHandler, logout, loader} from '../../../libs/helper'

export default {
    beforeCreate(){
        if (this.$route.params && this.$route.params.verificationKey) {
            let query = {
                key: this.$route.params.verificationKey,
                type: this.$route.params.type
            };
            loader(this, true);
            verifiyEmail(query)
                .then((response)=> {
                    if (response.success) {
                        localStorage.clear()
                        loader(this, false);
                        message(this, constants.messageType.SUCCESS,('Verification successful'));
                    }
                })
                .catch((error)=> {
                    loader(this, false);
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                })

        }
    },
    data () {
        return {
            passwordType: 'password',
            dynamicValidateForm: {
                email: '',
                password: ''
            }
        }
    },
    methods: {
        hideShowPassword(type){
            this.passwordType = type;
        },
        forgotPassword(){
            this.$router.push(pageRoutes.forgotPassword)
        },
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    loader(this, true);
                    signin(this.dynamicValidateForm)
                        .then((response) => {
                            if (response && response.id) {
                                loader(this, false);
                                // route to redirect path if available or home
                                this.$router.push(sessionStorage.getItem('redirectPath') || pageRoutes.home)
                                // remove redirectPath from session storage
                                sessionStorage.removeItem('redirectPath')
                                localStorage.setItem('activeProfile', '')
                            }
                        })
                        .catch((error) => {
                            // remove redirectPath from session storage
                            sessionStorage.removeItem('redirectPath')
                            loader(this, false);
                            if(error.code === 'EMAIL_NOT_VERIFIED'){
                                const message = `<div class='resend-verification'><span class='rv-message'>email address not confirmed yet</span> <a href='${process.env.VUE_APP_WEB_BASE_URL}/resend-verification' id='link' class='rv-link'>resend confirmation email</a> </div>`
                                this.$message({
                                    dangerouslyUseHTMLString: true,
                                    type: 'error',
                                    showClose: true,
                                    duration:5000,
                                    message: message
                                });
                            }else{
                                message(this, constants.messageType.ERROR, errorHandler(error))
                            }
                        })
                }
            })
        }
    }
}